import React from "react";
import "../../styles/partnerships.css";
import { Helmet } from "react-helmet-async";

export default function PartnershipsPage() {
  return (
    <>
    <Helmet>
  <title>Educational Partnerships & CSR Programs – PracVerse</title>
  <link rel="icon" href="/favicon.ico" />
<link rel="shortcut icon" href="/favicon.ico" />
<link rel="apple-touch-icon" href="/favicon.ico" />

  <meta
    name="description"
    content="Partner with PracVerse for drone-based STEM education, curriculum integration, CSR-funded programs and future-tech labs for schools and colleges."
  />
  <link rel="canonical" href="https://www.pracverse.com/partnerships" />

  <meta property="og:title" content="Educational Partnerships & CSR Programs – PracVerse" />
  <meta
    property="og:description"
    content="School, college, NGO and CSR partnerships for practical, future-ready drone and STEM learning."
  />
  <meta property="og:url" content="https://www.pracverse.com/partnerships" />
  <meta property="og:image" content="https://www.pracverse.com/images/og-partnerships.jpg" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Educational Partnerships & CSR Programs",
      "url": "https://www.pracverse.com/partnerships",
      "about": [
        "school drone labs",
        "CSR education programs",
        "STEM partnerships",
        "NGO education initiatives"
      ]
    })}
  </script>
</Helmet>



    <div className="partnerships-page">

        {/* /* PARTNERS HERO START */}
    <header className="partners-hero-hero">
    <div className="partners-hero-inner container" role="banner">
        <h1 className="partners-hero-title">Educational Partnerships</h1>

        <p className="partners-hero-sub">
        Transform your institution's STEM education with our comprehensive drone technology programs.
        We partner with Schools, Colleges, NGOs, and Corporates, leverage CSR funding to make cutting-edge education
        accessible to all students.
        </p>

        <div className="partners-hero-ctas" role="region" aria-label="Partnership calls to action">
        <a className="btn primary large" href="/contact">Start Partnership</a>
        <a className="btn outline large" href="#learn_more" style={{ marginLeft: 14 }}>Learn More</a>
        </div>
    </div>
    </header>
    {/* /* PARTNERS HERO END */ }


      {/* WHY PARTNER SECTION */}
    <section id="why-partner" className="why-partner-section">
    <div className="container">
        <header className="why-header" style={{ textAlign: "center", marginBottom: 28 }}>
        <h2>Why Partner With Us?</h2>
        <p className="why-sub">
            Our partnerships go beyond traditional education, providing comprehensive support and resources
            to ensure your students receive world-class drone education.
        </p>
        </header>

        <div className="why-grid">
        <article className="why-card">
            <div className="why-icon" aria-hidden="true">
            {/* book icon */}
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6.5A2.5 2.5 0 0 1 5.5 4H19" stroke="#1F2340" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3 19.5A2.5 2.5 0 0 0 5.5 22H19" stroke="#1F2340" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3 6.5v13M19 4v18" stroke="#1F2340" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            </div>
            <h3>Curriculum Integration</h3>
            <p>Seamlessly integrate Drone Education into existing STEM curricula with our comprehensive lesson plans and materials.</p>
        </article>

        <article className="why-card">
            <div className="why-icon" aria-hidden="true">
            {/* teacher icon */}
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" stroke="#1F2340" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M21 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" stroke="#1F2340" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            </div>
            <h3>Student Skill Development</h3>
            <p>Hands-on learning that builds critical 21st-century skills including problem-solving, creativity, coding, and real-world tech exposure.</p>
        </article>

        <article className="why-card">
            <div className="why-icon" aria-hidden="true">
            {/* ribbon/cert icon */}
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2l3 6 6 .9-4.5 4 1 6L12 16l-5.5 2.9 1-6L3 8.9 9 8 12 2z" stroke="#1F2340" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </svg>
            </div>
            <h3>Certification Programs</h3>
            <p>Industry-recognized certifications for students and tech enthusiasts, enhancing career prospects and institutional credibility.</p>
        </article>

        <article className="why-card">
            <div className="why-icon" aria-hidden="true">
            {/* equipment icon */}
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="5" width="18" height="14" rx="2" stroke="#1F2340" strokeWidth="1.5" />
                <path d="M8 9h8M8 13h8" stroke="#1F2340" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            </div>
            <h3>Equipment & Resources</h3>
            <p>Access to state-of-the-art drone technology, software, and educational materials at institutional pricing.</p>
        </article>
        </div>
    </div>
    </section>




    {/* PARTNERSHIP OPPORTUNITIES */}
<section id="opportunities" className="partnership-opportunities section">
  <div className="container">
    <header className="opp-header" style={{ textAlign: "center", marginBottom: 26 }}>
      <h2 id="learn_more">Partnership Opportunities</h2>
      <p className="opp-sub">
        We offer flexible partnership models designed to meet the unique needs of different educational
        cohorts and institutes.
      </p>
    </header>

    <div className="opp-grid">
      {/* Card: Schools Partnership */}
      <article className="opp-card">
        <div className="opp-media">
          <img src="/images/School.png" alt="Schools Partnership" />
        </div>

        <div className="opp-body">
          <div className="opp-header-row">
            <div className="opp-icon" aria-hidden="true">👥</div>
            <h3 className="opp-title">Schools Partnership</h3>
          </div>

          <p className="opp-intro">Empowering 3-12 students with foundational drone education and STEM skills.</p>

          <div className="opp-section">
            <h4>Program Details</h4>
            <p>Our school partnership program integrates drone technology into existing STEM curricula, offering hands-on course on drone building, block programming, basic AI/ML concepts, and safe flying practices. Programs are tailored for different age groups, from elementary introductions to advanced high-school projects.</p>
          </div>

          <div className="opp-section">
            <h4>Key Benefits</h4>
            <ul className="opp-bullets">
              <li><span className="csr-check">✓</span> Access to curriculum-aligned lesson plans and professional instructors</li>
              <li><span className="csr-check">✓</span> Engaging hands on project based learning that builds 21st-century skills</li>
              <li><span className="csr-check">✓</span> Flexible timelines: in-class modules, after-school clubs, or transformative workshop</li>
            </ul>
          </div>

          <div className="opp-section">
            <h4>How to Collaborate</h4>
            <p>Contact our outreach team to schedule a consultation. We will discuss curriculum fit, teacher training, and program customisation to match your school's needs and budget.</p>
          </div>
        </div>
      </article>

      {/* Card: Colleges/Universities Partnership */}
      <article className="opp-card">
        <div className="opp-media">
          <img src="/images/College.png" alt="College Partnership" />
        </div>

        <div className="opp-body">
          <div className="opp-header-row">
            <div className="opp-icon" aria-hidden="true">🎓</div>
            <h3 className="opp-title">Colleges / Universities Partnership</h3>
          </div>

          <p className="opp-intro">Advanced drone courses and research opportunities for higher-education students.</p>

          <div className="opp-section">
            <h4>Program Details</h4>
            <p>We collaborate with colleges and universities to offer specialised drone courses including advanced programming (Python, C++), AI/ML for autonomy, drone videography/cinematography, and drone-based data collection & analysis. Programs may be offered as electives, certificate courses, or research projects.</p>
          </div>

          <div className="opp-section">
            <h4>Key Benefits</h4>
            <ul className="opp-bullets">
              <li><span className="csr-check">✓</span> Research & project collaboration opportunities for students and faculty</li>
              <li><span className="csr-check">✓</span> Industry-relevant curriculum aligned to technology and media programs</li>
              <li><span className="csr-check">✓</span> Access to internship and placement pathways with partner organisations</li>
            </ul>
          </div>

          <div className="opp-section">
            <h4>How to Collaborate</h4>
            <p>University departments can contact our academic partnerships lead to co-design courses, guest lectures, joint research initiatives, and lab access agreements.</p>
          </div>
        </div>
      </article>



        {/* NGOs/Community Programs Partnership*/}
      <article className="opp-card">
        <div className="opp-media">
          <img src="/images/NGO.png" alt="NGO" />
        </div>

        <div className="opp-body">
          <div className="opp-header-row">
            <div className="opp-icon" aria-hidden="true">🎓</div>
            <h3 className="opp-title">NGOs/Community Programs Partnership</h3>
          </div>

          <p className="opp-intro">Bringing drone education to underserved communities through non-profit collaborations.</p>

          <div className="opp-section">
            <h4>Program Details</h4>
            <p>Our NGO partnership program focuses on making drone education accessible to youth in underserved communities. We provide mobile workshops and tailored programs that introduce drone technology, coding, and flying skills, aiming to inspire interest in STEM fields and provide pathways to future employment. Programs are often run in community centers or after-school settings.</p>
          </div>

          <div className="opp-section">
            <h4>Key Benefits</h4>
            <ul className="opp-bullets">
              <li><span className="csr-check">✓</span> Research & project collaboration opportunities for students and faculty</li>
              <li><span className="csr-check">✓</span> Industry-relevant curriculum aligned to engineering and media programs</li>
              <li><span className="csr-check">✓</span> Access to internship and placement pathways with partner organisations</li>
            </ul>
          </div>

          <div className="opp-section">
            <h4>How to Collaborate</h4>
            <p>Non-profit organizations interested in hosting drone education programs should contact our community engagement team. We will work together to secure funding, identify target demographics, and customize a program that meets community needs.</p>
          </div>
        </div>
      </article>


      {/* CSR Funding Initiatives Partnership */}
      <article className="opp-card">
        <div className="opp-media">
          <img src="/images/part_CSR.png" alt="CSR" />
        </div>

        <div className="opp-body">
          <div className="opp-header-row">
            <div className="opp-icon" aria-hidden="true">🎓</div>
            <h3 className="opp-title">CSR Funding Initiatives Partnership</h3>
          </div>

          <p className="opp-intro">Leveraging Corporate Social Responsibility funds to expand drone education outreach.</p>

          <div className="opp-section">
            <h4>Program Details</h4>
            <p>We partner with corporations seeking to fulfill their CSR objectives by investing in impactful educational programs. CSR funds enable us to provide scholarships, establish drone labs in schools, develop specialized curricula for disadvantaged groups, and expand our reach to more students who otherwise wouldn't have access to this technology. We offer transparent reporting on impact and reach.</p>
          </div>

          <div className="opp-section">
            <h4>Key Benefits</h4>
            <ul className="opp-bullets">
              <li><span className="csr-check">✓</span> Research & project collaboration opportunities for students and faculty</li>
              <li><span className="csr-check">✓</span> Industry-relevant curriculum aligned to engineering and media programs</li>
              <li><span className="csr-check">✓</span> Access to internship and placement pathways with partner organisations</li>
            </ul>
          </div>

          <div className="opp-section">
            <h4>How to Collaborate</h4>
            <p>Companies interested in supporting drone education through their CSR initiatives are invited to connect with our corporate partnerships manager. We can develop bespoke programs that align with your company's values and CSR goals, offering various levels of engagement and recognition.</p>
          </div>
        </div>
      </article>
    </div>



  </div>
</section>




{/* HOW WE COLLABORATE */}
<section id="how-we-collaborate" className="how-collaborate-section">
  <div className="container">
    <header className="how-header" style={{ textAlign: "center", marginBottom: 28 }}>
      <h2>How We Collaborate</h2>
      <p className="how-sub">
        Our proven partnership process ensures seamless integration and maximum impact for your educational programs.
      </p>
    </header>

    <div className="how-grid">
      <article className="how-step">
        <div className="how-badge">01</div>
        <h3 className="how-title">Initial Consultation</h3>
        <p className="how-desc">
          We assess your institution's needs, goals, and current capabilities to design a customized partnership program.
        </p>
      </article>

      <article className="how-step">
        <div className="how-badge">02</div>
        <h3 className="how-title">Program Design</h3>
        <p className="how-desc">
          Together, we develop a tailored curriculum that aligns with your educational objectives and student demographics.
        </p>
      </article>

      <article className="how-step">
        <div className="how-badge">03</div>
        <h3 className="how-title">Implementation</h3>
        <p className="how-desc">
          Our team provides comprehensive training, equipment setup, and ongoing support to ensure successful program launch.
        </p>
      </article>

      <article className="how-step">
        <div className="how-badge">04</div>
        <h3 className="how-title">Continuous Support</h3>
        <p className="how-desc">
          Ongoing mentorship, curriculum updates, and technical support to maintain program excellence and student engagement.
        </p>
      </article>
    </div>
  </div>
</section>




{/* CSR FUNDING OPPORTUNITIES */}
<section id="csr-funding" className="csr-funding-section">
  <div className="container csr-grid">
    <div className="csr-left">
      <h2 className="csr-title">CSR Funding Opportunities</h2>

      <p className="csr-lead">
        We help organizations leverage Corporate Social Responsibility (CSR) funds to support educational initiatives.
        Our programs align with CSR objectives while providing measurable impact on student learning and community development.
      </p>

      <ul className="csr-list">
        <li><span className="csr-check">✓</span> Compliance with CSR regulations and guidelines</li>
        <li><span className="csr-check">✓</span> Detailed impact reporting and documentation</li>
        <li><span className="csr-check">✓</span> Sustainable educational program development</li>
        <li><span className="csr-check">✓</span> Community engagement and stakeholder involvement</li>
      </ul>

      <div style={{ marginTop: 18 }}>
        <a className="btn primary" href="/contact">Explore CSR Partnerships</a>
      </div>
    </div>

    <div className="csr-right">
      <div className="csr-media-frame">
        <img src="/images/CSR_opp.png" alt="CSR partnership meeting" />
      </div>
    </div>
  </div>
</section>




{/* PARTNERS CTA BANNER */}
<section className="partners-cta-banner">
  <div className="container">
    <div className="partners-cta-inner">
      <h2>Ready to Transform Education Together?</h2>
      <p>
        Join our network of educational partners and bring the future of STEM learning to your students.
        Let's create opportunities that inspire and prepare the next generation of innovators.
      </p>

      <div className="partners-cta-actions">
        <a className="btn cta-white" href="/contact">Start Your Partnership</a>
        <a className="btn cta-outline" href="/courses" style={{ marginLeft: 12 }}>View Our Programs</a>
      </div>
    </div>
  </div>
</section>



      
    </div>
    </>
  );
}
